import React from 'react';

import StrokeIcon, { StrokeIconProps } from './StrokeIcon';

export default function ChevronDownIcon(props: StrokeIconProps): JSX.Element {
  return (
    <StrokeIcon {...props}>
      <path d="m6 9 6 6 6-6" />
    </StrokeIcon>
  );
}
